/* eslint-disable react/prop-types */
import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

const ReiseHero = (props) => (
  <div className="reise-hero w-auto max-w-[920px] mx-auto mt-16">
    <GatsbyImage image={props.img} alt="" />
    <h2 className="reise-hero-headline">{props.title}</h2>
  </div>
)
export default ReiseHero
